<!--  请假申请页面  -->
<template>
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        请假申请
        <small>请假申请</small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> 请假申请
          </a>
        </li>
        <li class="active">请假申请</li>
      </ol>
    </section>
    <!-- Main content -->
    <section class="content">
      <div class="col-sm-12">
        <div id="atptoolbar"></div>

        <!--  申请表单  -->
        <div class="apply-form">
          <!-- modal-body-->
          <div class="modal-body">

            <div class="panel-body">

              <div class="form-group">
                <label class="control-sidebar-subheading col-sm-6">
                  请假类别
                  <input type="text" class="form-control" v-model="form.formCategory"
                         placeholder="请输入请假类别"/>
                </label>
                <label class="control-sidebar-subheading col-sm-6">
                  请假事由
                  <input type="text" class="form-control" v-model="form.formReason"
                         placeholder="请输入请假事由"/>
                </label>
              </div>

              <!-- 开始时间 -->
              <div class="form-group">
                <label class="control-label col-xs-12 col-sm-6 no-padding-right"
                       for="formStart">开始时间:
                  <input
                    id="formStart"
                    name="formStart"
                    type="text"
                    class="form-control field"
                    @click="datePicker('formStart')"
                  />
                </label>
                <label class="control-label col-xs-12 col-sm-6 no-padding-right"
                       for="formEnd">结束时间:
                  <input
                    id="formEnd"
                    name="formEnd"
                    type="text"
                    class="form-control field"
                    @click="datePicker('formEnd')"
                  />
                  <!--                                    <input id="formEnd" v-model="formEnd" name="formEnd" type="text" class="form-control field"/>-->
                </label>
              </div>

            </div>

          </div>
          <!-- modal-footer -->
          <div class="modal-footer">
            <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
            <button type="button" class="btn btn-primary" @click="submit">确定</button>
          </div>
        </div>

      </div>
    </section>
  </div>
</template>

<script>

  import {datepicker} from 'eonasdan-bootstrap-datetimepicker'

  export default {
    name: 'applyLeave',
    data() {
      return {
        form: {
          formCategory: '', // 请假类别
          formReason: '', // 请假事由
          formStart: '', // 开始日期
          formEnd: '' // 结束日期
        }
      }
    },
    components: {datepicker},
    mounted: function () {
    },
    methods: {
      submit: function () { // 发起请假申请
        let self = this
        const company = localStorage.getItem('companyInfo')

        if (!self.form.formCategory || !self.form.formReason || !self.form.formStart || !self.form.formEnd) {
          alert('请将申请单填写完毕')
          return
        }

        if (self.form.formStart > self.form.formEnd) {
          alert('请假时间不合理')
          return
        }

        const formData = {
          '公司ID': JSON.parse(company).id,
          '请假类别': self.form.formCategory,
          '请假事由': self.form.formReason,
          '开始日期': self.form.formStart,
          '结束日期': self.form.formEnd
        }

        console.log('___提交表单 formData', formData)
        self.global.axiosPost(self, 'apply/1/', formData, function (res) {
          console.log('/apply/1/', res)
          if (res.status === 'success') {
            alert('提交成功')
          }
        })
      },

      datePicker: function (elementId) {
        let self = this
        WdatePicker({
          el: elementId,
          dateFmt: 'yyyy-MM-dd HH:mm:ss', //日期格式，可以只显示年或年月，也可以额外显示时间
          onpicked: function () {
            var value = $('#' + elementId).val()
            console.log('___日期elementId', elementId, value)
            // var timeStamp = self.global.timeToStamp(value)
            self.form[elementId] = value
          },
          oncleared: function () {
            self[elementId] = null
          },
          isShowClear: true,
          readOnly: true
        })
      },
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/applyWorkflow/applyLeave.vue